module.exports = __webpack_public_path__ + "img/zid.5d4bbfe6.png";